import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Contact } from "@/components/Contact";
import { Seo } from "@/components/Seo";
import { PAGE_SEO } from "@/data/seo";

export default function ContactPage() {
  return (
    <main className="min-h-screen" data-testid="contact-page-main">
      <Seo {...PAGE_SEO.contact} />
      <Header />
      <div className="pt-24" data-testid="contact-page">
        <Contact />
      </div>
      <Footer />
    </main>
  );
}
